import BaseController from "../baseController";

export class ProfileController {
  urlBase = "/profiles";

  constructor() {
    this.base = BaseController;
  }

  async getProfiles(userId) {
    if (typeof userId !== "string")
        throw new Error("Invalid user id.");
    return this.base._get(`${this.urlBase}?$filter=userId eq '${userId}' `);
  }
}

const profileController = new ProfileController();

export default profileController;